{
  "Welcome, please create your account": "Välkommen! Skapa ditt konto.",
  "External login": "Inloggning",
  "Email": "E-post",
  "Password": "Lösenord",
  "Password does not match": "Lösenordet matchar inte",
  "Invalid Email Address": "Ogiltig e-postadress",
  "Password needs a minimum of: ": "Lösenordet behöver minst: ",
  "8 characters": "8 tecken",
  "1 uppercase character": "1 stor bokstav",
  "1 lowercase character": "1 liten bokstav",
  "1 number": "1 siffra",
  "Verification email sent": "Verifiering skickad med e-post",
  "verify-account": "Du behöver verifiera ditt konto för att logga in. Följ instruktionerna du fick via e-post när du skapade ditt konto.",
  "no-email-resend": "Fick du ingen e-post? Klicka för att försöka igen.",
  "Login": "Logga in",
  "Create account": "Skapa konto",
  "Internal login": "Logga in med SSO",
  "use-sso": "Använd single sign-on (SSO) för att logga in automatiskt.",
  "Reset password": "Återställ lösenord",
  "Reset": "Återställ",
  "Resend": "Skicka igen",
  "Cancel": "Avbryt",
  "A message has been sent to": "Ett meddelande har skickats till",
  "Repeat password": "Upprepa lösenord",
  "Your password was updated successfully": "Ditt lösenord har uppdaterats.",
  "Go to login": "Logga in",
  "Set password": "Skapa lösenord",
  "First name": "Förnamn",
  "Last name": "Efternamn",
  "Confirm password": "Bekräfta lösenord",
  "Your account was created successfully.": "Ditt konto har skapats.",
  "confirmation-email": "En bekräftelse har skickats till dig.",
  "Go to login page": "Logga in",
  "Sign up": "Registrera",
  "Make sure that you are using your company email address.": "Använd din företags-epost.",
  "password-requirements": "Lösenordet måste innehålla minst 8 tecken, varav minst en stor och liten bokstav och en siffra.",
  "The provided token is not valid": "Den token som angivits är inte giltig",
  "Unknown error. Please try again or contact customer support": "Okänt fel. Försök igen eller kontakta support.",
  "token-expired": "Din verifieringstoken har gått ut. Klicka på knappen nedan för att få en ny token",
  "Resend verification": "Skicka på nytt",
  "Go to start page": "Sätt igång!",
  "Your account has been verified": "Ditt konto har verifierats.",
  "Success": "Det lyckades!",
  "A new verification email has been sent to you": "En ny bekräftelse har skickats.",
  "Enter your email to reset": "Fyll i din e-post för att återställa ditt lösenord.",
  "password-reset-email-message": "Klicka på länken i e-posten för att sätta nytt lösenord. Om du inte ser något, vänta 5 minuter och kontrollera din skräppost.",
  "canvas-error": "Det uppstod ett fel under canvas autentiseringen"
}
